

export class TimeZoneUpdateInput implements ITimeZoneUpdateInput {
    /** The auto-generated id of the time zone master */
    timeZoneId!: number;
    /** The time zone with 255 character limit */
    timeZone!: string;
    /** The time difference between time zone time zone master */
    timeDifference!: number;

    constructor(data?: ITimeZoneUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.timeZone = _data["timeZone"];
            this.timeDifference = _data["timeDifference"];
        }
    }

    static fromJS(data: any): TimeZoneUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["timeZone"] = this.timeZone;
        data["timeDifference"] = this.timeDifference;
        return data; 
    }
}

export interface ITimeZoneUpdateInput {
    /** The auto-generated id of the time zone master */
    timeZoneId: number;
    /** The time zone with 255 character limit */
    timeZone: string;
    /** The time difference between time zone time zone master */
    timeDifference: number;
}

